/* RESPONSIBLE TEAM: team-automation-foundations */
import EscalationController from 'embercom/controllers/apps/app/automation/fin-ai-agent/escalation';

export default class AutomationFinAIAgentEcommerceEscalationController extends EscalationController {}
